var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-6 col-xl-8 vh-100 d-flex flex-column justify-content-between align-items-center"},[_c('DateTime'),(_vm.getOverlayOpen === 'PlayerControls')?_c('PlayerControls'):_vm._e(),_c('ChannelInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }